import React, { useEffect, useRef, useState } from "react";

import Above from "core-web/components/Breakpoints/Above";
import Below from "core-web/components/Breakpoints/Below";
import ChevronIcon from "theme/components/icons/ChevronIcon";
import Div from "theme/layouts/Div";
// import FilterButton from "./FilterButton";
import PropTypes from "prop-types";
import Row from "theme/layouts/Row";
// import ScrollableBox from "core-web/components/ScrollableBox";
import SortOptions from "theme/components/Filter/FilterBar/SortOptions";
import TextStyles from "theme/components/text/TextStyles";
import ThemeButton from "theme/components/buttons/ThemeButton";
// import ToggleFilter from "theme/components/Filter/FilterBar/ToggleFilter";
import colors from "theme/config/colors";
import getNavResponsiveProps from "theme/overlays/getNavResponsiveProps";
import showOverlay from "core-web/state/models/Overlay/dispatches/showOverlay";
import styled from "theme/libs/styled";
import useAboveBreakpoint from "core-web/hooks/useAboveBreakpoint";
import useIntersectionObserver from "core-web/hooks/useIntersectionObserver";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import variables from "theme/config/variables";
import { withRouter } from "react-router-dom";

const NavToggleWrapper = styled("div")`
    position: fixed;
    inset: auto 20px 8px;
    z-index: 1;
    transition: transform ${({ theme }) => theme.transitions.primary};

    &[data-visibly-hidden="true"] {
        transform: translateY(calc(100% + 8px));
    }
`;

const SortButtonWrapper = styled("div")`
    //Todo: sticky sorting on desktop
    /* &[data-is-pinned="true"] {
        position: fixed;
        z-index: 3;
    } */
`;

// Keeping filter stuff for later use
// const FilterButtons = styled(ScrollableBox)`
//     display: flex;
//     margin-bottom: 16px;
//     margin-top: 16px;
//     gap: 8px;

//     ${({ theme }) => theme.above.tabletLg} {
//         width: 100%;
//     }
// `;

// const isFullUrl = (url) => {
//     try {
//         new URL(url);

//         return true;
//     } catch (e) {
//         return false;
//     }
// };

const FilterBar = ({
    handleChange,
    scrollToTop,
    hitsCount,
    sorts,
    // filterState,
    // shouldScrollState,
    // filterOverlayData,
    // config,
    // filterButtons,
    // clear,
}) => {
    const { t } = useTranslation();
    const isDesktop = useAboveBreakpoint("tabletLg");

    const stickyRef = useRef(null);
    const [isPinned, setIsPinned] = useState(false);

    const { searchIsOpen } = useSelector(({ header }) => header.states);
    const { top } = getNavResponsiveProps(searchIsOpen, false, 12);
    // const top = isDesktop
    //     ? `${variables.headerHeight}px`
    //     : getNavResponsiveProps(false, searchIsOpen, topMenuIsOpen, headerIsMinimized, false, 8);

    const stickyElement = stickyRef.current;

    const currentSort = sorts.filter((sort) => sort.selected)?.[0];

    useEffect(() => {
        const topOffsetDesktop = 0;
        const topOffsetMobile = searchIsOpen ? 0 : 45;
        const topOffset = isDesktop ? topOffsetDesktop : topOffsetMobile;
        const rootTopMargin = isDesktop
            ? variables.headerHeight
            : variables.headerHeightTablet + variables.searchInputHeightTablet;

        const options = {
            rootMargin: `-${rootTopMargin - topOffset}px 0px 0px 0px`,
            threshold: [0, 1],
        };

        const observer = new IntersectionObserver(([e]) => {
            if (e.boundingClientRect.y <= rootTopMargin) {
                setIsPinned(true);
            } else if (e.intersectionRatio <= 1) {
                setIsPinned(false);
            }
        }, options);

        if (stickyElement) {
            observer.observe(stickyElement);
        }

        return () => {
            if (stickyElement) {
                observer.unobserve(stickyElement);
            }
        };
    }, [stickyElement, isDesktop, searchIsOpen]);

    const [topBarRef, setTopBarRef] = useIntersectionObserver();
    const [footerRef, setFooterRef] = useIntersectionObserver();

    useEffect(() => {
        setTopBarRef(document.getElementById("top-bar"));
        setFooterRef(document.getElementById("site-footer"));
    }, []);

    // Keeping filter stuff for later use
    // const transformedFilterButtons = filterButtons
    //     .map(({ filter_link: filterLink, text }, index) => {
    //         if (!filterLink) {
    //             return null;
    //         }
    //         return {
    //             link: `${filterLink}&filterId=${index}`,
    //             text,
    //             id: index,
    //             isInternalLink: !isFullUrl(filterLink),
    //         };
    //     })
    //     .filter((filterButton) => !!filterButton);

    const openOverlay = () => {
        showOverlay("sort_overlay", { sorts, handleChange: handleChange.sort, scrollToTop });
    };
    return (
        <>
            <Div ref={stickyRef} />
            {/* {!!transformedFilterButtons?.length && (
                <FilterButtons scrollDirection="horizontal">
                    {transformedFilterButtons.map(({ text, link, isInternalLink }, index) => (
                        <FilterButton link={link} isInternalLink={isInternalLink} clear={clear} id={index}>
                            {text}
                        </FilterButton>
                    ))}
                </FilterButtons>
            )} */}
            <Row
                id="top-bar"
                data-is-pinned={isPinned}
                justifyContent="space-between"
                alignItems="center"
                py="4px"
                borderTop={`1px solid ${colors.neutral_100}`}
            >
                {/* <ToggleFilter
                        filterState={filterState}
                        shouldScrollState={shouldScrollState}
                        isPinned={isPinned}
                        config={config}
                        filterOverlayData={filterOverlayData}
                    /> */}

                <TextStyles
                    textStyles={["Myriad Pro/16-100", null, null, null, "Myriad Pro/14-100"]}
                    color={colors.black_70}
                >
                    {t(hitsCount === 1 ? "filter.product_count" : "filter.product_count_plural", { count: hitsCount })}
                </TextStyles>

                <SortButtonWrapper data-is-pinned={isPinned} top={top} right={`${variables.sitePaddingXDesktop}px`}>
                    <Below
                        breakpoint="tabletLg"
                        render={() => (
                            <ThemeButton
                                buttonTheme="transparent"
                                size="xs"
                                padding="16px 0"
                                alignItems="center"
                                onClick={openOverlay}
                                aria-label={t("aria_labels.open_nav")}
                            >
                                <TextStyles
                                    as="span"
                                    textStyles={["Myriad Pro/16-100", null, null, null, "Myriad Pro/14-100"]}
                                >
                                    {t("filter.sort")}
                                </TextStyles>
                                <ChevronIcon direction="down" />
                            </ThemeButton>
                        )}
                    />
                    <Above
                        breakpoint="tabletLg"
                        render={() => (
                            <SortOptions
                                sorts={sorts}
                                handleChange={handleChange.sort}
                                scrollToTop={scrollToTop}
                                isPinned={isPinned}
                            />
                        )}
                    />
                </SortButtonWrapper>
            </Row>
            <Below
                breakpoint="tabletLg"
                render={() => (
                    <NavToggleWrapper data-visibly-hidden={footerRef?.isIntersecting || topBarRef?.isIntersecting}>
                        <ThemeButton
                            buttonTheme="white_solid"
                            size="xs"
                            width="min(385px, 100%)"
                            m="auto"
                            boxShadow="0px 4px 36px 0px rgba(0, 0, 0, 0.08)"
                            alignItems="center"
                            onClick={openOverlay}
                            aria-label={t("aria_labels.open_nav")}
                        >
                            {`${t("filter.sort")} / ${currentSort.label}`}
                            <ChevronIcon direction="down" />
                        </ThemeButton>
                    </NavToggleWrapper>
                )}
            />
        </>
    );
};

FilterBar.propTypes = {
    config: PropTypes.object.isRequired,
    filterOverlayData: PropTypes.shape({
        clear: PropTypes.func,
        config: PropTypes.object,
        filters: PropTypes.array,
        handleChange: PropTypes.func,
        hasCategoryFilter: PropTypes.bool,
        hitsCount: PropTypes.number,
        scrollToTop: PropTypes.func,
        searchOpen: PropTypes.bool,
        selectedFilters: PropTypes.array,
    }).isRequired,
    filterState: PropTypes.array.isRequired,
    handleChange: PropTypes.shape({
        filter: PropTypes.shape({
            value: PropTypes.func,
            range: PropTypes.func,
        }),
        sort: PropTypes.func,
    }).isRequired,
    hitsCount: PropTypes.number,
    shouldScrollState: PropTypes.array.isRequired,
    scrollToTop: PropTypes.func,
    sorts: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    filterButtons: PropTypes.array,
    clear: PropTypes.object.isRequired,
};

FilterBar.defaultProps = {
    hitsCount: undefined,
    scrollToTop: () => {},
    filterButtons: [],
};

export default withRouter(FilterBar);
